import { Banner, Button, Loader } from '@kanda-libs/ks-design-library';

import {
  BUTTON_LARGE_PROPS,
  BUTTON_SMALL_PROPS,
  CLASS_NAMES,
} from './CompleteAccountBadge-constants';
import Container from './CompleteAccountBadge-container';

const ViewComponent = () => (
  <Container>
    {({ showBanner, onClick, isSubmitting }) =>
      showBanner && (
        <div className="md:mt-10 border rounded-lg border-purple-100">
          <Banner>
            <div className={CLASS_NAMES.container}>
              <div className={CLASS_NAMES.textWrapper}>
                <span className={CLASS_NAMES.title}>
                  Finish set up to send your first Job
                </span>
                <span className={CLASS_NAMES.subTitle}>
                  Complete Company Set Up
                </span>
              </div>
              <div className={CLASS_NAMES.link}>
                <Button.Text onClick={onClick} {...BUTTON_LARGE_PROPS} />
                <Button.Text onClick={onClick} {...BUTTON_SMALL_PROPS} />
              </div>
            </div>
          </Banner>
          <Loader isLoading={isSubmitting} />
        </div>
      )
    }
  </Container>
);

ViewComponent.displayName = 'CompleteAccountBadge-view';

export default ViewComponent;
